// Custom Tooltip Content - Dùng cho axisContent
export default function CustomTooltipContent(props: any) {
    const { axisValue, series, axisData, mode } = props;

    if (!axisValue) return null;

    // Tìm index của axisValue trong xLabels
    const dataIndex = axisData?.x?.index;

    // Lấy giá trị từ series data tại index tương ứng
    const value = series && series.length > 0 && dataIndex !== undefined
        ? series[0].data[dataIndex]
        : null;

    const year = new Date().getFullYear();

    // Xác định label và format value dựa vào mode
    const isCompletionMode = mode === 'completion';
    const label = isCompletionMode ? 'Tỉ lệ:' : 'Số lượng:';
    const displayValue = typeof value === 'number'
        ? (isCompletionMode ? `${value}%` : value.toLocaleString())
        : '0';

    return (
        <div style={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '12px 16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            width: '180px',
        }}>
            <div style={{
                fontWeight: 600,
                color: '#032F9C',
                marginBottom: '8px',
                fontSize: '14px'
            }}>
                {axisValue},  {year}
            </div>
            <div style={{
                fontWeight: 700,
                color: '#000',
                fontSize: '14px'
            }}>
                {label} {displayValue}
            </div>
        </div>
    );
}